export default __webpack_public_path__ + "static/media/ticongle.467d37e8.png";